import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';

const VehicleList = ({ vehicles, onEdit, onDelete }) => {
    if (!vehicles || vehicles.length === 0) {
        return <div className="text-center py-4 text-gray-500">No vehicles found.</div>;
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            {vehicles.map(vehicle => (
                <div key={vehicle.id} className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="text-xl font-semibold text-gray-800">{vehicle.name}</h3>
                    <p className="text-gray-600 mt-2 text-sm">{vehicle.description}</p>
                    {vehicle.photoURL && (
                        <img src={vehicle.photoURL} alt={vehicle.name} className="mt-4 w-full h-40 object-cover rounded" />
                    )}
                    <div className="mt-4 flex justify-end space-x-2">
                        <button
                            onClick={() => onEdit(vehicle)}
                            className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                        >
                            <Pencil size={20} />
                        </button>
                        <button
                            onClick={() => onDelete(vehicle.id)}
                            className="p-2 rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition"
                        >
                            <Trash2 size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VehicleList;